<script setup lang="ts">
import { computed, ref } from 'vue'
import useSelector from '@/views/chat/components/selector'
import type { SelectorExpose, TreeItem } from '@/types'

const props = withDefaults(defineProps<{ list: TreeItem[] }>(), { list: () => [] })

const value = ref()
const { filterList, handleFilter } = useSelector(props.list, 1)

const subList = computed(() => {
  return filterList.value.map((index) => {
    const item = props.list[+index]
    return {
      label: item.label,
      value: item.value,
      realIndex: index,
    }
  })
})

defineExpose<SelectorExpose<string>>({
  getResult: () => value.value,
  setValue: (v) => {
    value.value = v
  },
  handleFilter,
})
</script>

<template>
  <div class="selector-component single-selector">
    <template v-for="item in subList">
      <div class="text-left list-item" :class="{ active: item.value === value }" @click="value = item.value">
        <div>{{ item.label }}</div>
        <v-icon icon="mdi-check" v-if="item.value === value" />
        <span class="v-icon" v-else></span>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
@import 'selector';

.selector-component .list-item {
  line-height: 1.3;
  padding: 0.7rem 2rem 0.7rem 0.7rem;
}
</style>
